(function () {
  function initProductTabs(root) {
    var tabsRoot=root.querySelector('[data-nt-product-tabs]');
    if(!tabsRoot||tabsRoot.dataset.ntTabsInitialized==='true')return;
    tabsRoot.dataset.ntTabsInitialized='true';tabsRoot.classList.add('nt-pdp-anchor-sections');
    var nav=tabsRoot.querySelector('.nt-pdp-tabs__list'),names=['description','shipping','reviews'];
    var tabs=names.map(function(name){return tabsRoot.querySelector('[data-nt-product-tab="'+name+'"]');});
    var panels=names.map(function(name){return tabsRoot.querySelector('[data-nt-product-panel="'+name+'"]');});
    nav.setAttribute('role','navigation');
    tabs.forEach(function(tab,i){nav.append(tab);tab.removeAttribute('role');tab.removeAttribute('aria-selected');tab.tabIndex=0;
      var panel=panels[i];panel.hidden=false;panel.classList.add('is-active');panel.setAttribute('role','region');tabsRoot.append(panel);
      if(names[i]==='reviews'){var heading=document.createElement('h2');heading.className='nt-pdp-anchor-heading';heading.textContent=['DESCRIPTION','SHIPPING & REFUND','REVIEWS'][i];panel.prepend(heading);}
    });
    function headerHeight(){
      var height=0;
      document.querySelectorAll('header,[data-sticky-header],.sticky-header').forEach(function(el){
        if(root.contains(el))return;var style=getComputedStyle(el),r=el.getBoundingClientRect();
        if((style.position==='fixed'||style.position==='sticky')&&r.top<=1&&r.bottom>0&&r.height<200)height=Math.max(height,r.bottom);
      });return height;
    }
    function activate(name){tabs.forEach(function(tab){var on=tab.dataset.ntProductTab===name;tab.classList.toggle('is-active',on);if(on)tab.setAttribute('aria-current','location');else tab.removeAttribute('aria-current');});}
    function go(name){var i=names.indexOf(name);if(i<0)return;var offset=headerHeight();nav.style.top=offset+'px';
      window.scrollTo({top:Math.max(0,scrollY+panels[i].getBoundingClientRect().top-offset-nav.offsetHeight-16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      activate(name);
    }
    tabs.forEach(function(tab,i){tab.addEventListener('click',function(){go(names[i]);});tab.addEventListener('keydown',function(e){var next=e.key==='ArrowRight'?(i+1)%3:e.key==='ArrowLeft'?(i+2)%3:e.key==='Home'?0:e.key==='End'?2:null;if(next!==null){e.preventDefault();tabs[next].focus();go(names[next]);}});});
    // Delegate so late-rendered or recomposed rating summaries use the same section navigation.
    root.addEventListener('click',function(e){
      var link=e.target.closest&&e.target.closest('a[href="#reviews"],.nt-pdp__rating,.nt-pc-review');
      if(!link||!root.contains(link))return;
      e.preventDefault();e.stopImmediatePropagation();go('reviews');
    },true);
    var queued=false;
    function update(){queued=false;var offset=headerHeight();nav.style.top=offset+'px';var active=0;panels.forEach(function(panel,i){if(panel.getBoundingClientRect().top<=offset+nav.offsetHeight+40)active=i;});activate(names[active]);}
    function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
    window.addEventListener('scroll',schedule,{passive:true,signal:root._ntProductSignal});window.addEventListener('resize',schedule,{signal:root._ntProductSignal});update();
    if(location.hash==='#reviews')requestAnimationFrame(function(){go('reviews');});
  }

  function initProductReviewList(root) {
    var section = root.querySelector('[data-nt-product-reviews]');
    if (!section || section.dataset.ntReviewsInitialized === 'true') return;
    section.dataset.ntReviewsInitialized = 'true';

    var savedLikes = [];
    try { savedLikes = JSON.parse(localStorage.getItem('nt-product-review-helpful') || '[]'); } catch (_error) { savedLikes = []; }
    section.querySelectorAll('[data-nt-product-review-item]').forEach(function (review) {
      var button = review.querySelector('[data-nt-review-helpful]');
      if (!button) return;
      var id = review.dataset.reviewId;
      var baseLikes = Number(review.dataset.likes || 0);

      function render() {
        var liked = savedLikes.indexOf(id) !== -1;
        button.classList.toggle('is-liked', liked);
        button.setAttribute('aria-pressed', String(liked));
        var count = button.querySelector('b');
        if (count) count.textContent = String(baseLikes + (liked ? 1 : 0));
      }

      button.addEventListener('click', function () {
        savedLikes = savedLikes.indexOf(id) !== -1
          ? savedLikes.filter(function (item) { return item !== id; })
          : savedLikes.concat(id);
        localStorage.setItem('nt-product-review-helpful', JSON.stringify(savedLikes));
        render();
      });
      render();
    });
  }

  function initProduct(root) {
    if (root.dataset.ntProductInitialized === 'true') return;
    root.dataset.ntProductInitialized = 'true';
    var lifecycle=new AbortController();root._ntProductSignal=lifecycle.signal;
    root.addEventListener('nt:product:unload',function(){lifecycle.abort();root.dispatchEvent(new Event('shopify:section:unload'));},{once:true});
    document.documentElement.classList.add('nt-pdp-has-product-page');

    var mainImage = root.querySelector('[data-nt-main-image]');
    var gallery = root.querySelector('[data-nt-product-gallery]');
    var galleryPrevious = root.querySelector('[data-nt-gallery-prev]');
    var galleryNext = root.querySelector('[data-nt-gallery-next]');
    var thumbnailTrack = root.querySelector('[data-nt-gallery-thumbs]');
    var thumbnailsPrevious = root.querySelector('[data-nt-thumbs-prev]');
    var thumbnailsNext = root.querySelector('[data-nt-thumbs-next]');
    var imageCount = root.querySelector('[data-nt-image-count]');
    var thumbnails = Array.from(root.querySelectorAll('[data-nt-product-thumb]'));
    var activeImageIndex = Math.max(0, thumbnails.findIndex(function (button) {
      return button.classList.contains('is-active');
    }));
    var thumbnailShell = thumbnailTrack && thumbnailTrack.closest('.nt-pdp__thumbs-shell');
    var thumbnailFrame = 0;
    var thumbnailResizeObserver;
    var thumbnailMutationObserver;

    function verticalThumbnails() {
      return thumbnailTrack && getComputedStyle(thumbnailTrack).flexDirection === 'column';
    }

    function revealThumbnail(button) {
      if (!thumbnailTrack || !button || !thumbnailTrack.clientHeight) return;
      var vertical = verticalThumbnails();
      var trackRect = thumbnailTrack.getBoundingClientRect();
      var buttonRect = button.getBoundingClientRect();
      var start = vertical ? buttonRect.top - trackRect.top : buttonRect.left - trackRect.left;
      var end = vertical ? buttonRect.bottom - trackRect.bottom : buttonRect.right - trackRect.right;
      var distance = start < 0 ? start : end > 0 ? end : 0;
      if (distance) thumbnailTrack.scrollBy({
        top: vertical ? distance : 0,
        left: vertical ? 0 : distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function updateThumbnails() {
      thumbnailFrame = 0;
      if (!thumbnailShell || !gallery) return;
      var height = Math.floor(gallery.getBoundingClientRect().height);
      if (height > 0) thumbnailShell.style.setProperty('--nt-gallery-height', height + 'px');
      var vertical = verticalThumbnails();
      var first = thumbnailTrack.firstElementChild;
      var last = thumbnailTrack.lastElementChild;
      var contentSize = 0;
      if (first && last) {
        var firstRect = first.getBoundingClientRect();
        var lastRect = last.getBoundingClientRect();
        contentSize = vertical ? lastRect.bottom - firstRect.top : lastRect.right - firstRect.left;
      }
      var available = vertical ? height : thumbnailShell.clientWidth;
      var overflow = contentSize > available + 1;
      thumbnailShell.classList.toggle('nt-thumbs-has-overflow', overflow);
      var position = vertical ? thumbnailTrack.scrollTop : thumbnailTrack.scrollLeft;
      var maximum = vertical ? thumbnailTrack.scrollHeight - thumbnailTrack.clientHeight : thumbnailTrack.scrollWidth - thumbnailTrack.clientWidth;
      if (thumbnailsPrevious) thumbnailsPrevious.disabled = !overflow || position <= 1;
      if (thumbnailsNext) thumbnailsNext.disabled = !overflow || position >= maximum - 1;
    }

    function queueThumbnails() {
      if (!thumbnailFrame) thumbnailFrame = window.requestAnimationFrame(updateThumbnails);
    }

    function scrollThumbnails(direction) {
      var vertical = verticalThumbnails();
      var first = thumbnailTrack.firstElementChild;
      var size = first ? (vertical ? first.offsetHeight : first.offsetWidth) : 68;
      var gap = parseFloat(getComputedStyle(thumbnailTrack).gap) || 0;
      var step = size + gap;
      var visible = vertical ? thumbnailTrack.clientHeight : thumbnailTrack.clientWidth;
      var distance = direction * Math.max(1, Math.floor(visible / step) - 1) * step;
      thumbnailTrack.scrollBy({
        top: vertical ? distance : 0,
        left: vertical ? 0 : distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    if (thumbnailShell && gallery) {
      thumbnailShell.classList.add('nt-thumbs-enhanced');
      [thumbnailsPrevious, thumbnailsNext].forEach(function (button, index) {
        if (!button) return;
        var label = index ? root.dataset.thumbnailsNextLabel : root.dataset.thumbnailsPreviousLabel;
        if (label) button.setAttribute('aria-label', label);
        var icon = document.createElement('i');
        icon.className = index ? 'fa fa-angle-right' : 'fa fa-angle-left';
        icon.setAttribute('aria-hidden', 'true');
        button.replaceChildren(icon);
      });
      thumbnailTrack.addEventListener('scroll', queueThumbnails, { passive: true });
      window.addEventListener('resize', queueThumbnails, { passive: true });
      thumbnailResizeObserver = new ResizeObserver(queueThumbnails);
      thumbnailResizeObserver.observe(gallery);
      thumbnailResizeObserver.observe(thumbnailTrack);
      thumbnailMutationObserver = new MutationObserver(function (records) {
        queueThumbnails();
        if (records.some(function (record) { return record.type === 'attributes'; })) {
          revealThumbnail(thumbnailTrack.querySelector('.is-active'));
        }
      });
      thumbnailMutationObserver.observe(thumbnailTrack, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      root.addEventListener('shopify:section:unload', function () {
        window.cancelAnimationFrame(thumbnailFrame);
        window.removeEventListener('resize', queueThumbnails);
        thumbnailResizeObserver.disconnect();
        thumbnailMutationObserver.disconnect();
      });
      queueThumbnails();
    }

    function setMainImage(imageUrl, imageAlt) {
      if (!mainImage || !imageUrl) return;

      // The original responsive srcset otherwise overrides a newly assigned src.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageUrl;
      mainImage.alt = imageAlt || root.dataset.productTitle || '';
    }

    function selectImage(index, shouldFocus) {
      if (!thumbnails.length) return;
      var normalizedIndex = (index + thumbnails.length) % thumbnails.length;
      var button = thumbnails[normalizedIndex];

      activeImageIndex = normalizedIndex;
      setMainImage(button.dataset.image, button.dataset.alt);
      if (imageCount) {
        var currentCount = imageCount.querySelector('b');
        if (currentCount) currentCount.textContent = String(normalizedIndex + 1);
        imageCount.setAttribute('aria-label', 'Image ' + (normalizedIndex + 1) + ' of ' + thumbnails.length);
      }
      thumbnails.forEach(function (item, itemIndex) {
        var isActive = itemIndex === normalizedIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      revealThumbnail(button);
      if (shouldFocus) button.focus({ preventScroll: true });
    }

    thumbnails.forEach(function (button, index) {
      button.addEventListener('click', function () {
        selectImage(index, false);
      });
    });

    if (galleryPrevious) galleryPrevious.addEventListener('click', function () { selectImage(activeImageIndex - 1, false); });
    if (galleryNext) galleryNext.addEventListener('click', function () { selectImage(activeImageIndex + 1, false); });
    if (thumbnailTrack && thumbnailsPrevious) thumbnailsPrevious.addEventListener('click', function () {
      scrollThumbnails(-1);
    });
    if (thumbnailTrack && thumbnailsNext) thumbnailsNext.addEventListener('click', function () {
      scrollThumbnails(1);
    });

    if (gallery && thumbnails.length > 1) {
      var pointerStartX = 0;
      var pointerStartY = 0;
      var activePointerId = null;

      gallery.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        activePointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });

      gallery.addEventListener('pointerup', function (event) {
        if (activePointerId !== event.pointerId) return;
        var deltaX = event.clientX - pointerStartX;
        var deltaY = event.clientY - pointerStartY;
        activePointerId = null;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
        selectImage(activeImageIndex + (deltaX < 0 ? 1 : -1), false);
      });

      gallery.addEventListener('pointercancel', function () {
        activePointerId = null;
      });

      gallery.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        selectImage(activeImageIndex + (event.key === 'ArrowRight' ? 1 : -1), false);
      });
    }

    function normalizeVehicleText(value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    function isMissingFitment(value) {
      return !value || /^(?:NTFAIRINGS?|SEE PRODUCT TITLE|CHECKING PRODUCT FITMENT)$/i.test(String(value).trim());
    }

    function inferFitment() {
      var fitment = root.querySelector('[data-nt-fitment]');
      if (fitment && fitment.dataset.customerSelectsFitment === 'true') return;
      var source = root.dataset.productTitle || document.title || '';
      var sourceUpper = source.toUpperCase();
      var sourceNormalized = normalizeVehicleText(source);
      var brandElement = root.querySelector('[data-nt-fitment-brand]');
      var modelElement = root.querySelector('[data-nt-fitment-model]');
      var yearElement = root.querySelector('[data-nt-fitment-year]');
      var brandInput = root.querySelector('[data-nt-fitment-brand-input]');
      var modelInput = root.querySelector('[data-nt-fitment-model-input]');
      var yearInput = root.querySelector('[data-nt-fitment-year-input]');
      var brand = brandElement ? brandElement.textContent.trim() : '';
      var model = modelElement ? modelElement.textContent.trim() : '';
      var year = yearElement ? yearElement.textContent.trim() : '';
      var brands = ['Honda', 'Yamaha', 'Kawasaki', 'Suzuki', 'BMW', 'Ducati', 'Triumph', 'Aprilia'];
      var compoundModels = [];

      function addCompoundModels(models) {
        models.forEach(function (candidate) {
          if (compoundModels.indexOf(candidate) === -1) compoundModels.push(candidate);
        });
      }

      if (isMissingFitment(brand)) {
        brand = brands.find(function (candidate) {
          return sourceUpper.indexOf(candidate.toUpperCase()) !== -1;
        }) || '';
      }

      // Some product titles abbreviate a shared model prefix, for example
      // "GSXR600/750". A direct substring match sees GSXR 600 but misses
      // GSXR 750, so preserve every model represented by these known ranges.
      if (/\bGSX-?R\s*600\s*(?:(?:\/|&|\+|AND)\s*)?(?:GSX-?R\s*)?750\b/i.test(source)) {
        addCompoundModels(['GSXR 600', 'GSXR 750']);
      }
      if (/\bYZF[-\s]*R25\s*(?:\/|&|\+|AND)\s*(?:YZF[-\s]*)?R3\b/i.test(source)) {
        addCompoundModels(['YZF R25', 'YZF R3']);
      }
      if (/\bGROM\s*(?:\/|&|\+|AND)\s*MSX\s*125\b/i.test(source)) {
        addCompoundModels(['Grom / MSX125']);
      }
      if (/\b848\s*(?:\/|&|\+|AND)\s*1098\s*(?:\/|&|\+|AND)\s*1198\b/i.test(source)) {
        addCompoundModels(['848', '1098', '1198']);
      }

      if (isMissingFitment(model) || compoundModels.length) {
        var options = window.NTVehicleOptions && window.NTVehicleOptions[brand] || {};
        var matches = Object.keys(options).map(function (candidate) {
          return { label: candidate, key: normalizeVehicleText(candidate) };
        }).filter(function (candidate) {
          return candidate.key && sourceNormalized.indexOf(candidate.key) !== -1;
        }).sort(function (a, b) { return b.key.length - a.key.length; });
        matches = matches.filter(function (candidate, index, all) {
          return !all.some(function (other, otherIndex) {
            return otherIndex < index && other.key.indexOf(candidate.key) !== -1;
          });
        });
        var inferredModels = compoundModels.slice();
        matches.forEach(function (match) {
          if (inferredModels.indexOf(match.label) === -1) inferredModels.push(match.label);
        });
        model = inferredModels.slice(0, 4).join(' / ');

        if (!model) {
          var modelMatch = sourceUpper.match(/\b(CBR\s?\d{3,4}(?:RR-R|RR|R|F|F4I)?|ZX-?\d{1,2}R|EX\d{3}|GSX-?R?\s?\d{3,4}|YZF\s?R\d|R\d{1,2}|FZ\dR?|MT-?\d{2}|S1000R{1,2}|K\d{4}S?|SV650|TL1000R)\b/i);
          if (modelMatch) model = modelMatch[1].replace(/\s+/g, ' ').trim();
        }
      }

      if (isMissingFitment(year)) {
        var range = source.match(/\b((?:19|20)\d{2})\s*(?:-|–|\/|TO)\s*((?:(?:19|20)\d{2})|\d{2})\b/i);
        var single = source.match(/\b((?:19|20)\d{2})\b/);
        if (range) {
          var end = range[2].length === 2 ? range[1].slice(0, 2) + range[2] : range[2];
          year = range[1] + '–' + end;
        } else if (single) {
          year = single[1];
        }
      }

      brand = brand || 'Contact fitment support';
      model = model || 'Contact fitment support';
      year = year || 'Contact fitment support';
      if (brandElement) brandElement.textContent = brand;
      if (modelElement) modelElement.textContent = model;
      if (yearElement) yearElement.textContent = year;
      if (brandInput) brandInput.value = brand;
      if (modelInput) modelInput.value = model;
      if (yearInput) yearInput.value = year;
    }

    inferFitment();

    var fitmentGuide = root.querySelector('[data-nt-fitment-guide]');
    if (fitmentGuide && window.NTFitmentGuide) {
      var inferredBrand = root.querySelector('[data-nt-fitment-brand]');
      var inferredModels = root.querySelector('[data-nt-fitment-model]');
      var inferredYears = root.querySelector('[data-nt-fitment-year]');
      window.NTFitmentGuide.render(fitmentGuide, {
        brand: root.dataset.vehicleBrand || (inferredBrand && inferredBrand.textContent),
        models: root.dataset.vehicleModels || (inferredModels && inferredModels.textContent),
        years: root.dataset.modelYears || (inferredYears && inferredYears.textContent),
        sku: root.dataset.productSku || ''
      });
    }

    var variantSelect = root.querySelector('[data-nt-variant-select]');
    var price = root.querySelector('[data-nt-price]');
    var couponPrice = root.querySelector('[data-nt-coupon-price]');
    var compare = root.querySelector('[data-nt-compare-price]');
    var discountPercent = root.querySelector('[data-nt-discount-percent]');
    var addButton = root.querySelector('[data-nt-add-to-cart]');
    var addLabel = root.querySelector('[data-nt-add-label]');
    var buyNowButton = root.querySelector('[data-nt-buy-now]');
    var buyNowLabel = root.querySelector('[data-nt-buy-label]');
    var productForm = addButton && (addButton.form || addButton.closest('form') || root.querySelector('form[action*="/cart/add"]'));
    var mobileAddButton = document.querySelector('[data-nt-mobile-add]');
    var mobileAddLabel = document.querySelector('[data-nt-mobile-add-label]');
    var mobileCartButton = document.querySelector('[data-nt-mobile-cart]');
    var purchaseBusy = false;
    var addedLabelTimer;
    var fitmentSelectionsComplete = false;
    function optionOrderable(){var option=variantSelect&&variantSelect.options[variantSelect.selectedIndex];return !option||option.dataset.displayOnly!=='true';}
    var selectedVariantAvailable = root.dataset.currentAvailable === 'true' && optionOrderable();
    var unavailableLabel = root.dataset.unavailableLabel || 'UNAVAILABLE';
    var unavailableNote = root.dataset.unavailableNote || 'This product option is currently unavailable. Contact us to check availability and shipping options.';

    function updateAvailabilityNotice() {
      root.querySelectorAll('[data-nt-availability-details]').forEach(function (element) {
        element.hidden = !selectedVariantAvailable;
      });
      root.querySelectorAll('[data-nt-unavailable-notice]').forEach(function (element) {
        element.hidden = selectedVariantAvailable;
      });
      root.querySelectorAll('[data-nt-unavailable-heading]').forEach(function (element) {
        element.textContent = unavailableLabel;
      });
      root.querySelectorAll('[data-nt-unavailable-message]').forEach(function (element) {
        element.textContent = unavailableNote;
      });
    }
    var shippingEstimateLabel = root.querySelector('[data-nt-shipping-estimate]');
    var shippingEstimatePill = shippingEstimateLabel && shippingEstimateLabel.closest('.nt-pdp__mobile-fact');
    var shippingEstimateTimer = null;
    var shippingEstimateRun = 0;

    function getShopifyRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function getSelectedVariantId() {
      if (variantSelect) return variantSelect.value;
      var idInput = productForm && productForm.querySelector('input[name="id"]');
      return idInput ? idInput.value : '';
    }

    function formatShippingPrice(price) {
      var amount = Number(price);
      if (!Number.isFinite(amount)) amount = Number(String(price || '').replace(/[^0-9.]/g, ''));
      var currency = root.dataset.moneyCurrency || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function setShippingEstimate(text) {
      if (!shippingEstimateLabel || !shippingEstimatePill) return;
      if (!text) {
        shippingEstimateLabel.textContent = '';
        shippingEstimatePill.hidden = true;
        return;
      }
      shippingEstimateLabel.textContent = text;
      shippingEstimatePill.hidden = false;
    }

    function effectiveShippingDestination() {
      var countryCode = String(root.dataset.shippingCountryCode || '').toUpperCase();
      var country = root.dataset.shippingCountry || '';
      var province = String(root.dataset.shippingProvince || '').toUpperCase();
      var zip = root.dataset.shippingZip || '';
      return { countryCode: countryCode, country: country, province: province, zip: zip };
    }

    function applyKnownShippingPolicy() {
      var destination = effectiveShippingDestination();
      var fulfillment = root.dataset.fulfillment || '';
      if (!selectedVariantAvailable) {
        setShippingEstimate('Shipping calculated at checkout');
        return true;
      }
      if ((fulfillment === 'us' || fulfillment === 'preorder') && destination.countryCode === 'US') {
        setShippingEstimate(destination.province === 'AK' || destination.province === 'HI' ? 'Shipping only $400' : 'Free shipping');
        return true;
      }
      if ((fulfillment === 'us' || fulfillment === 'preorder') && (destination.countryCode === 'CA' || destination.countryCode === 'MX')) {
        setShippingEstimate('Shipping only $200');
        return true;
      }
      if (fulfillment === 'china') {
        setShippingEstimate('Shipping only $100');
        return true;
      }
      return false;
    }

    function queueShippingEstimate() {
      if (!shippingEstimateLabel) return;
      if (applyKnownShippingPolicy()) return;
      setShippingEstimate('Shipping calculated at checkout');
    }

    function updateVariant() {
      if (!variantSelect) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      selectedVariantAvailable = option && option.dataset.available === 'true' && optionOrderable();
      root.dataset.ntDisplayVariant=String(!optionOrderable());
      root.dataset.currentAvailable=String(selectedVariantAvailable);
      unavailableLabel = option && option.dataset.unavailableLabel || 'UNAVAILABLE';
      unavailableNote = option && option.dataset.unavailableNote || 'This product option is currently unavailable. Contact us to check availability and shipping options.';
      if(!optionOrderable()){unavailableLabel=root.dataset.ntDisplayLabel;unavailableNote=root.dataset.ntDisplayNote;}
      var currentCurrency = window.NTRedesignCurrency && window.NTRedesignCurrency.current ? window.NTRedesignCurrency.current() : '';
      if (option && price) {
        price.dataset.ntMoneyCents = option.dataset.priceCents || '';
        price.innerHTML = window.NTRedesignCurrency && option.dataset.priceCents
          ? window.NTRedesignCurrency.format(Number(option.dataset.priceCents), currentCurrency, price.dataset.ntMoneyBase)
          : option.dataset.price || '';
      }
      if (option && couponPrice) {
        couponPrice.dataset.ntMoneyCents = option.dataset.couponPriceCents || '';
        couponPrice.innerHTML = window.NTRedesignCurrency && option.dataset.couponPriceCents
          ? window.NTRedesignCurrency.format(Number(option.dataset.couponPriceCents), currentCurrency, couponPrice.dataset.ntMoneyBase)
          : option.dataset.couponPrice || '';
      }
      if (compare) {
        compare.dataset.ntMoneyCents = option ? option.dataset.comparePriceCents || '' : '';
        compare.innerHTML = window.NTRedesignCurrency && option && option.dataset.comparePriceCents
          ? window.NTRedesignCurrency.format(Number(option.dataset.comparePriceCents), currentCurrency, compare.dataset.ntMoneyBase)
          : (option ? option.dataset.comparePrice || '' : '');
        compare.hidden = !option || !option.dataset.comparePrice;
      }
      if (discountPercent) {
        var priceCents = Number(option && option.dataset.priceCents || 0);
        var compareCents = Number(option && option.dataset.comparePriceCents || 0);
        var hasDiscount = compareCents > priceCents && priceCents >= 0;
        discountPercent.hidden = !hasDiscount;
        discountPercent.textContent = hasDiscount ? '-' + Math.round((compareCents - priceCents) * 100 / compareCents) + '%' : '';
      }
      if (option && option.dataset.image && mainImage) {
        var variantImage = option.dataset.image;
        var matchingIndex = thumbnails.findIndex(function (button) {
          return button.dataset.image === variantImage;
        });
        if (matchingIndex >= 0) selectImage(matchingIndex, false);
        else setMainImage(variantImage, root.dataset.productTitle || '');
      }
      if (addLabel && !selectedVariantAvailable) addLabel.textContent = unavailableLabel;
      updateFitment();
      queueShippingEstimate();
    }

    var confirmed = root.querySelector('[data-nt-fitment-confirm]');
    var note = root.querySelector('[data-nt-fitment-note]');
    var fitment = root.querySelector('[data-nt-fitment]');
    var customerSelectsFitment = Boolean(fitment && fitment.dataset.customerSelectsFitment === 'true');
    var brandSelect = root.querySelector('[data-nt-fitment-brand-select]');
    var modelSelect = root.querySelector('[data-nt-fitment-model-select]');
    var yearSelect = root.querySelector('[data-nt-fitment-year-select]');
    var brandOther = root.querySelector('[data-nt-fitment-brand-other]');
    var modelOther = root.querySelector('[data-nt-fitment-model-other]');
    var yearOther = root.querySelector('[data-nt-fitment-year-other]');
    var brandInput = root.querySelector('[data-nt-fitment-brand-input]');
    var modelInput = root.querySelector('[data-nt-fitment-model-input]');
    var yearInput = root.querySelector('[data-nt-fitment-year-input]');

    function setOptions(select, placeholder, values) {
      if (!select) return;
      select.innerHTML = '';
      var prompt = document.createElement('option');
      prompt.value = '';
      prompt.textContent = placeholder;
      select.appendChild(prompt);
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      var otherOption = document.createElement('option');
      otherOption.value = 'Other';
      otherOption.textContent = 'Other';
      select.appendChild(otherOption);
    }

    function toggleOther(select, input) {
      if (!select || !input) return '';
      var isOther = select.value === 'Other';
      input.hidden = !isOther;
      input.disabled = !isOther;
      input.required = isOther;
      if (!isOther) input.value = '';
      return isOther ? input.value.trim() : select.value;
    }

    function resetConfirmation() {
      if (confirmed) confirmed.checked = false;
    }

    function syncCustomerFitment() {
      if (!customerSelectsFitment) return;
      var brand = toggleOther(brandSelect, brandOther);
      var model = toggleOther(modelSelect, modelOther);
      var year = toggleOther(yearSelect, yearOther);
      if (brandInput) brandInput.value = brand;
      if (modelInput) modelInput.value = model;
      if (yearInput) yearInput.value = year;
    }

    function populateModels() {
      if (!brandSelect || !modelSelect || !yearSelect) return;
      var brand = brandSelect.value;
      var options = window.NTVehicleOptions || {};
      var models = brand && brand !== 'Other' ? Object.keys(options[brand] || {}).sort() : [];
      setOptions(modelSelect, 'Choose model', models);
      modelSelect.disabled = !brand;
      setOptions(yearSelect, 'Choose year', []);
      yearSelect.disabled = true;
      if (brand === 'Other') {
        modelSelect.value = 'Other';
        yearSelect.disabled = false;
        yearSelect.value = 'Other';
      }
      resetConfirmation();
      syncCustomerFitment();
      updateFitment();
    }

    function populateYears() {
      if (!brandSelect || !modelSelect || !yearSelect) return;
      var options = window.NTVehicleOptions || {};
      var years = modelSelect.value && modelSelect.value !== 'Other'
        ? (options[brandSelect.value] && options[brandSelect.value][modelSelect.value] || [])
        : [];
      setOptions(yearSelect, 'Choose year', years);
      yearSelect.disabled = !modelSelect.value;
      if (modelSelect.value === 'Other') yearSelect.value = 'Other';
      resetConfirmation();
      syncCustomerFitment();
      updateFitment();
    }

    function initializeCustomerFitment() {
      if (!customerSelectsFitment || !brandSelect) return;
      setOptions(brandSelect, 'Choose brand', Object.keys(window.NTVehicleOptions || {}).sort());
      setOptions(modelSelect, 'Choose model', []);
      setOptions(yearSelect, 'Choose year', []);
      modelSelect.disabled = true;
      yearSelect.disabled = true;
      syncCustomerFitment();
    }

    function setPurchaseBusy(intent, busy) {
      purchaseBusy = busy;
      var label = intent === 'checkout'
        ? (busy ? 'OPENING CHECKOUT...' : 'BUY NOW')
        : (busy ? 'ADDING...' : 'ADD TO CART');
      if (intent === 'checkout') {
        if (buyNowLabel) buyNowLabel.textContent = label;
        if (mobileAddLabel) mobileAddLabel.textContent = label;
        if (buyNowButton) {
          buyNowButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) buyNowButton.setAttribute('aria-busy', 'true');
          else buyNowButton.removeAttribute('aria-busy');
        }
        if (mobileAddButton) {
          mobileAddButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) mobileAddButton.setAttribute('aria-busy', 'true');
          else mobileAddButton.removeAttribute('aria-busy');
        }
      } else {
        if (addLabel) addLabel.textContent = label;
        if (addButton) {
          addButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) addButton.setAttribute('aria-busy', 'true');
          else addButton.removeAttribute('aria-busy');
        }
        if (mobileCartButton) {
          mobileCartButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) mobileCartButton.setAttribute('aria-busy', 'true');
          else mobileCartButton.removeAttribute('aria-busy');
        }
      }
      [addButton, buyNowButton, mobileCartButton, mobileAddButton].forEach(function (button) {
        if (button) button.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
      });
    }

    function addSelectedItem(intent) {
      if (purchaseBusy || (window.NTCart && window.NTCart.busy) || !productForm || !optionOrderable() || !selectedVariantAvailable || !fitmentSelectionsComplete) return;
      window.clearTimeout(addedLabelTimer);
      var formData = new FormData(productForm);
      if (confirmed) confirmed.checked = true;
      formData.set('properties[Fitment confirmed]', 'Yes');
      setPurchaseBusy(intent, true);
      if (note) note.textContent = intent === 'checkout' ? 'Opening secure Shopify checkout...' : 'Adding the selected item...';

      var request = window.NTCart ? window.NTCart.add(formData) : fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (payload) { throw new Error(payload.description || payload.message || 'Unable to add this item.'); });
        return response.json();
      });
      request.then(function (payload) {
        if (intent === 'checkout') {
          window.location.assign(getShopifyRoot() + 'checkout');
          return;
        }
        if (!window.NTCart) { window.location.assign(getShopifyRoot() + 'cart'); return; }
        setPurchaseBusy('cart', false);
        if (note) note.textContent = payload.ntSyncWarning || 'Added to cart. Continue shopping or open the cart when ready.';
        if (addLabel) addLabel.textContent = 'ADDED';
        addedLabelTimer = window.setTimeout(function () { if (addLabel && !purchaseBusy) addLabel.textContent = 'ADD TO CART'; }, 1800);
      }).catch(function (error) {
        setPurchaseBusy(intent, false);
        if (note) note.textContent = error.message || 'Unable to continue. Please try again.';
      });
    }

    function updateFitment() {
      updateAvailabilityNotice();
      syncCustomerFitment();
      fitmentSelectionsComplete = !customerSelectsFitment || Boolean(
        brandInput && brandInput.value.trim() &&
        modelInput && modelInput.value.trim() &&
        yearInput && yearInput.value.trim()
      );
      if (purchaseBusy) return;
      if (addButton) addButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
      if (addLabel) addLabel.textContent = selectedVariantAvailable ? 'ADD TO CART' : unavailableLabel;
      if (buyNowButton) buyNowButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
      if (buyNowLabel) buyNowLabel.textContent = selectedVariantAvailable ? 'BUY NOW' : unavailableLabel;
      if (mobileCartButton) mobileCartButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
      if (mobileAddButton) {
        mobileAddButton.dataset.ready = fitmentSelectionsComplete && selectedVariantAvailable ? 'true' : 'false';
        mobileAddButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
        mobileAddButton.setAttribute('aria-label', !selectedVariantAvailable ? unavailableLabel : 'Buy now');
      }
      if (mobileAddLabel) mobileAddLabel.textContent = selectedVariantAvailable ? 'BUY NOW' : unavailableLabel;
      if (note) {
        note.textContent = !selectedVariantAvailable
          ? unavailableNote
          : customerSelectsFitment && !fitmentSelectionsComplete
              ? 'Select your brand, model and year to continue.'
              : '';
      }
    }

    // Reconcile stale HTML with Shopify's current-session variant availability.
    var availabilityRun = 0;
    function refreshAvailability() {
      if(!root.isConnected||lifecycle.signal.aborted)return;
      var handle=root.dataset.productHandle,id=getSelectedVariantId(),run=++availabilityRun;
      if(!handle||!id)return;
      fetch(getShopifyRoot()+'products/'+encodeURIComponent(handle)+'.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('Availability check failed');return r.json();})
      .then(function(p){
        if(lifecycle.signal.aborted||run!==availabilityRun||getSelectedVariantId()!==id)return;
        var v=(p.variants||[]).find(function(v){return String(v.id)===String(id);});
        if(!v||typeof v.available!=='boolean')return;
        selectedVariantAvailable=v.available&&optionOrderable();
        root.dataset.currentAvailable=String(selectedVariantAvailable);
        root.dataset.ntAvailabilityVerified='true';
        if(variantSelect){var option=variantSelect.options[variantSelect.selectedIndex];if(option)option.dataset.available=String(v.available);}
        updateFitment();queueShippingEstimate();
      }).catch(function(){root.dataset.ntAvailabilityVerified='failed';});
    }
    window.addEventListener('pageshow',refreshAvailability,{signal:lifecycle.signal});
    if(variantSelect)variantSelect.addEventListener('change',refreshAvailability);
    document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')refreshAvailability();},{signal:lifecycle.signal});
    refreshAvailability();

    initializeCustomerFitment();
    if (brandSelect) brandSelect.addEventListener('change', populateModels);
    if (modelSelect) modelSelect.addEventListener('change', populateYears);
    if (yearSelect) yearSelect.addEventListener('change', function () {
      resetConfirmation();
      syncCustomerFitment();
      updateFitment();
    });
    [brandOther, modelOther, yearOther].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        resetConfirmation();
        syncCustomerFitment();
        updateFitment();
      });
    });
    if (confirmed) confirmed.addEventListener('change', updateFitment);
    if (variantSelect) variantSelect.addEventListener('change', updateVariant);
    if (productForm) productForm.addEventListener('submit', function (event) { event.preventDefault(); });
    if (addButton) addButton.addEventListener('click', function () { addSelectedItem('cart'); });
    if (buyNowButton) buyNowButton.addEventListener('click', function () { addSelectedItem('checkout'); });
    if (mobileCartButton) mobileCartButton.addEventListener('click', function () { addSelectedItem('cart'); });
    if (mobileAddButton) mobileAddButton.addEventListener('click', function () { addSelectedItem('checkout'); });
    updateVariant();
    updateFitment();
    queueShippingEstimate();

    var shareToggle = root.querySelector('[data-nt-share-toggle]');
    var mobileShareToggle = document.querySelector('[data-nt-mobile-share]');
    var shareMenu = root.querySelector('[data-nt-share-menu]');
    var shareLabel = root.querySelector('[data-nt-share-label]');
    var shareWrap = root.querySelector('.nt-pdp__share');
    var shareQr = root.querySelector('[data-nt-share-qr]');
    var shareQrUrl = '';

    function getShareUrl() {
      var url = new URL(root.dataset.productUrl || window.location.href, window.location.origin);
      var removable = ['preview_theme_id', '_pos', '_sid', '_ss', 'fbclid', 'gclid'];
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (removable.indexOf(key) !== -1 || key.toLowerCase().indexOf('utm_') === 0) url.searchParams.delete(key);
      });
      return url.toString();
    }

    function setShareMenu(open) {
      if (!shareToggle || !shareMenu) return;
      shareToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      shareMenu.hidden = !open;
    }

    function updateShareLinks() {
      var url = getShareUrl();
      var title = root.dataset.productTitle || document.title;
      var image = root.dataset.productImage || '';
      root.querySelectorAll('[data-nt-share-network]').forEach(function (link) {
        var network = link.dataset.ntShareNetwork;
        if (network === 'facebook') link.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        if (network === 'instagram') {
          link.href = 'https://www.instagram.com/';
          link.dataset.ntCopyBeforeOpen = 'true';
        }
        if (network === 'tiktok') {
          link.href = 'https://www.tiktok.com/';
          link.dataset.ntCopyBeforeOpen = 'true';
        }
        if (network === 'x') link.href = 'https://x.com/intent/post?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title);
        if (network === 'reddit') link.href = 'https://www.reddit.com/submit?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
        if (network === 'pinterest') link.href = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&media=' + encodeURIComponent(image) + '&description=' + encodeURIComponent(title);
        if (network === 'whatsapp') link.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
        if (network === 'email') link.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
      });

      if (shareQr && window.QRCode && shareQrUrl !== url) {
        shareQr.innerHTML = '';
        new window.QRCode(shareQr, {
          text: url,
          width: 144,
          height: 144,
          colorDark: '#111315',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.M
        });
        shareQrUrl = url;
      }
    }

    function copyShareUrl() {
      var url = getShareUrl();
      var copied = navigator.clipboard && window.isSecureContext
        ? navigator.clipboard.writeText(url)
        : new Promise(function (resolve, reject) {
            var field = document.createElement('textarea');
            field.value = url;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            try { document.execCommand('copy') ? resolve() : reject(); }
            catch (error) { reject(error); }
            document.body.removeChild(field);
          });

      copied.then(function () {
        if (shareLabel) shareLabel.textContent = 'LINK COPIED';
        setShareMenu(false);
        window.setTimeout(function () { if (shareLabel) shareLabel.textContent = 'SHARE'; }, 1800);
      }).catch(function () {
        if (shareLabel) shareLabel.textContent = 'COPY FAILED';
        window.setTimeout(function () { if (shareLabel) shareLabel.textContent = 'SHARE'; }, 1800);
      });
    }

    if (shareToggle && shareMenu) {
      updateShareLinks();
      shareToggle.addEventListener('click', function () {
        if (navigator.share && !window.matchMedia('(min-width: 1024px)').matches) {
          navigator.share({
            title: root.dataset.productTitle || document.title,
            text: root.dataset.productTitle || document.title,
            url: getShareUrl()
          }).catch(function (error) {
            if (error && error.name !== 'AbortError') setShareMenu(true);
          });
          return;
        }
        setShareMenu(shareMenu.hidden);
      });

      var copyButton = shareMenu.querySelector('[data-nt-share-action="copy"]');
      if (copyButton) copyButton.addEventListener('click', copyShareUrl);
      shareMenu.querySelectorAll('[data-nt-copy-before-open="true"]').forEach(function (link) {
        link.addEventListener('click', function () {
          if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(getShareUrl()).catch(function () {});
        });
      });
      document.addEventListener('click', function (event) {
        if (shareWrap && !shareWrap.contains(event.target)) setShareMenu(false);
      },{signal:lifecycle.signal});
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setShareMenu(false);
      },{signal:lifecycle.signal});
    }
    function openNativeShareOrMenu() {
      if (navigator.share) {
        navigator.share({
          title: root.dataset.productTitle || document.title,
          text: root.dataset.productTitle || document.title,
          url: getShareUrl()
        }).catch(function (error) {
          if (error && error.name !== 'AbortError') setShareMenu(true);
        });
        return;
      }
      copyShareUrl();
    }

    if (mobileShareToggle) mobileShareToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openNativeShareOrMenu();
    });

    var mobileChatButton = document.querySelector('[data-nt-mobile-chat]');

    function openLiveChat(attempt) {
      if (typeof window.Chatra === 'function') {
        window.Chatra('openChat', true);
        return;
      }
      if (attempt < 10) {
        window.setTimeout(function () { openLiveChat(attempt + 1); }, 200);
      }
    }

    if (mobileChatButton) {
      mobileChatButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        document.documentElement.classList.add('nt-pdp-chat-open');
        document.querySelectorAll('.nt-pdp-chat-launcher-overlay').forEach(function (element) {
          element.classList.remove('nt-pdp-chat-launcher-overlay');
        });
        openLiveChat(0);
        window.setTimeout(function () {
          document.documentElement.classList.remove('nt-pdp-chat-open');
          window.dispatchEvent(new Event('resize'));
        }, 1800);
      });
    }

    initProductTabs(root);
    initProductReviewList(root);

  }

  var floatingUtilitiesReady=false;
  function initFloatingUtilityOffsets() {
    if(floatingUtilitiesReady)return;
    if (!window.matchMedia('(max-width: 767px)').matches || !document.querySelector('[data-nt-product]')) return;

    floatingUtilitiesReady=true;
    var scanQueued = false;
    var chatMatcher = /chatra|chat-widget|chat-launcher/i;

    function scan() {
      scanQueued = false;
      document.querySelectorAll('.nt-pdp-chat-launcher-overlay').forEach(function (element) {
        element.classList.remove('nt-pdp-chat-launcher-overlay');
      });
      document.querySelectorAll('body > *, body > * > iframe').forEach(function (element) {
        if (element.closest('[data-nt-product], .nt-pdp__mobile-bar, .nt-header')) return;
        var style = window.getComputedStyle(element);
        if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') return;
        var rect = element.getBoundingClientRect();
        if (rect.width < 30 || rect.width > 240 || rect.height < 28 || rect.height > 110) return;
        if (rect.bottom < window.innerHeight - 150) return;
        var identity = [element.id, element.className, element.getAttribute('title'), element.getAttribute('aria-label'), element.textContent]
          .filter(Boolean).join(' ');
        if (!document.documentElement.classList.contains('nt-pdp-chat-open') && chatMatcher.test(identity)) {
          element.classList.add('nt-pdp-chat-launcher-overlay');
        }
      });
    }

    function queueScan() {
      if (scanQueued) return;
      scanQueued = true;
      window.requestAnimationFrame(scan);
    }

    queueScan();
    [400, 1200, 3000, 7000].forEach(function (delay) { window.setTimeout(queueScan, delay); });
    window.addEventListener('resize', queueScan, { passive: true });
    window.addEventListener('orientationchange', queueScan, { passive: true });

    var observer = new MutationObserver(queueScan);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  function boot(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('[data-nt-product]').forEach(initProduct);
    if (scope.matches && scope.matches('[data-nt-product]')) initProduct(scope);
    if (document.querySelector('[data-nt-product]')) document.documentElement.classList.add('nt-pdp-has-product-page');
    initFloatingUtilityOffsets();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('nt:product:mount',function(event){boot(event.target);});
})();


(function () {
  function initTrustCenter(root) {
    var modal = root.querySelector('[data-nt-trust-modal]');
    var openButton = root.querySelector('[data-nt-trust-open]');
    if (!modal || !openButton || modal.dataset.ntTrustReady === 'true') return;
    modal.dataset.ntTrustReady = 'true';

    var dialog = modal.querySelector('[role="dialog"]');
    var closeButtons = modal.querySelectorAll('[data-nt-trust-close]');
    var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-nt-trust-tab]'));
    var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-nt-trust-panel]'));
    var previousFocus = null;

    function selectTab(name, focusTab) {
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-nt-trust-tab') === name;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-nt-trust-panel') === name;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
    }

    function openModal() {
      previousFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('nt-pdp-trust-open');
      selectTab('payment', false);
      window.requestAnimationFrame(function () {
        modal.scrollTop = 0;
        if (dialog) dialog.focus();
      });
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('nt-pdp-trust-open');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    openButton.addEventListener('click', openModal);
    closeButtons.forEach(function (button) { button.addEventListener('click', closeModal); });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(tab.getAttribute('data-nt-trust-tab'), false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (index + direction + tabs.length) % tabs.length;
        selectTab(tabs[next].getAttribute('data-nt-trust-tab'), true);
      });
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), a[href]')).filter(function (item) {
        return !item.hidden && item.offsetParent !== null && item.tabIndex !== -1;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bootTrustCenters(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('[data-nt-product]').forEach(initTrustCenter);
    if (scope.matches && scope.matches('[data-nt-product]')) initTrustCenter(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bootTrustCenters(); });
  else bootTrustCenters();

  document.addEventListener('shopify:section:load', function (event) {
    bootTrustCenters(event.target);
  });
  document.addEventListener('nt:product:mount',function(event){bootTrustCenters(event.target);});
})();

// Cabinet ETA is a warehouse-availability estimate, never an automatic arrival event.
(function(){
  function refreshPresaleDate(){
    var today=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Shanghai',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
    document.querySelectorAll('[data-nt-presale-eta]').forEach(function(node){
      var eta=node.dataset.ntPresaleEta;
      var label=node.querySelector('[data-nt-presale-date]');
      if(label)label.textContent=/^\d{4}-\d{2}-\d{2}$/.test(eta)&&eta>=today?eta:'Updated date pending.';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshPresaleDate);else refreshPresaleDate();
  setInterval(refreshPresaleDate,60000);
})();

// Shared fulfillment presentation. Existing source estimates remain authoritative.
(function(){
 function init(){document.querySelectorAll('[data-nt-product]').forEach(function(root){
  if(root.querySelector('.nt-shared-delivery'))return;
  var card=document.createElement('section');card.className='nt-shared-delivery';card.setAttribute('aria-label','Estimated delivery');
  card.innerHTML='<i class="fa fa-truck" aria-hidden="true"></i><div><h2>Estimated delivery</h2><p class="nt-shared-delivery__value"></p><p class="nt-shared-delivery__note"></p></div>';
  var value=card.querySelector('.nt-shared-delivery__value'),note=card.querySelector('.nt-shared-delivery__note');
  function text(el,copy){if(el.textContent!==copy)el.textContent=copy;}
  function sync(){
   var desktop=window.matchMedia('(min-width:1024px)').matches;
   var parent=desktop?root.querySelector('.nt-pc-info-scroll'):root.querySelector('.nt-pdp__details');
   if(!parent)return;
   if(card.parentNode!==parent)parent.appendChild(card);
   var type=root.dataset.fulfillment;
   var source=type==='us'?root.querySelector('[data-eta-result]'):root.querySelector('.nt-pc-delivery-unified h2, .nt-pdp__delivery #nt-delivery-title');
   var estimate=source?source.textContent.trim():'';
   // The live destination estimator can be empty before checkout has a usable address.
   // US-stock products still have a confirmed 3–5 business day service promise in
   // the native delivery block, so use that text instead of showing an error-like fallback.
   if(type==='us'&&!estimate){
    source=root.querySelector('.nt-pdp__delivery #nt-delivery-title');
    estimate=source?source.textContent.trim():'';
   }
   estimate=estimate.replace(/^Estimated delivery:\s*/i,'').replace(/^Delivery takes\s*/i,'');
   // Convert confirmed fulfillment durations to concrete estimated date ranges.
   var arrival=root.querySelector('[data-nt-presale-eta]');
   var raw=arrival?arrival.getAttribute('data-nt-presale-eta'):'';
   var match=(raw||'').match(/(\d{4})-(\d{2})-(\d{2})/);
   var base=new Date();base.setHours(12,0,0,0);
   var first,last;
   function plusDays(date,n,business){var result=new Date(date);while(n>0){result.setDate(result.getDate()+1);if(!business||(result.getDay()!==0&&result.getDay()!==6))n--;}return result;}
   if(type==='us'){
    var usDuration=estimate.match(/(\d+)\s*[\u2013-]\s*(\d+)\s*business days/i);
    if(usDuration){first=plusDays(base,Number(usDuration[1]),true);last=plusDays(base,Number(usDuration[2]),true);}
   }else if(type==='preorder'&&match){
     base=new Date(Number(match[1]),Number(match[2])-1,Number(match[3]),12);
     if(base>=new Date(new Date().setHours(0,0,0,0))){
      var duration=estimate.match(/(\d+)\s*[\u2013-]\s*(\d+)\s*business days/i);
      first=plusDays(base,duration?Number(duration[1]):3,true);last=plusDays(base,duration?Number(duration[2]):5,true);
     }else estimate='Delivery date pending warehouse arrival';
   }else if(type==='china'){
     first=plusDays(base,35,false);last=plusDays(base,42,false);
   }
   if(first&&last){var format=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric'});estimate=format.format(first)+' – '+format.format(last);}
   text(value,estimate||'See delivery details at checkout');
   var presale=root.querySelector('[data-nt-presale-date]');
   var detail=type==='preorder'?'Ships within 1 business day of US arrival · Delivery: 3–5 business days':type==='china'?'Production + delivery: about 5–6 weeks':'Ships within 1 business day · Delivery: 3–5 business days';
   text(note,detail);
   var title=root.querySelector('.nt-pdp__title-row');
   if(type==='china'&&title&&!root.querySelector('.nt-made-order-label')){
    var badge=document.createElement('span');badge.className='nt-made-order-label';badge.textContent='Made to order';title.insertBefore(badge,title.firstChild);
   }
  }
  var queued=false;function schedule(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;sync();});}
  var observer=new MutationObserver(schedule);observer.observe(root,{childList:true,subtree:true,characterData:true});
  root.addEventListener('nt:product:unload',function(){observer.disconnect();window.removeEventListener('resize',schedule);},{once:true});
  window.addEventListener('resize',schedule);sync();
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('nt:product:mount',init);
})();

(function(){
  function mount(root){
    if(!root||root.dataset.ntWidgetsReady)return;
    root.dataset.ntWidgetsReady='true';
    var dispose=[],alive=true;
    root.addEventListener('nt:product:unload',function(){alive=false;dispose.forEach(function(fn){fn();});},{once:true});
    var host=root.querySelector('[data-nt-owner-reviews]'),count=root.querySelector('[data-nt-top-review-count]');
    if(host&&root.dataset.ownerReviewsUrl){
      function sync(){if(count&&host.dataset.reviewCount)count.textContent=host.dataset.reviewCount+' Reviews';}
      var reviewsObserver=new MutationObserver(sync);
      reviewsObserver.observe(host,{attributes:true,attributeFilter:['data-review-count']});
      dispose.push(function(){reviewsObserver.disconnect();});
      root.dataset.ntReviewsState='loading';
      window.NTLoadOwnerReviews().then(function(module){if(alive){module.mount(host);sync();root.dataset.ntReviewsState='ready';delete root.dataset.ntReviewsError;}}).catch(function(error){root.dataset.ntReviewsState='failed';root.dataset.ntReviewsError=error.message;});
    }
    var widget=root.querySelector('.nt-pdp__afterpay'),price=root.querySelector('[data-nt-price]');
    if(widget&&price){
      function amount(){return (Number(price.dataset.ntMoneyCents)/100).toFixed(2);}
      function update(){
        var currency=window.NTRedesignCurrency?window.NTRedesignCurrency.current():root.dataset.shopCurrency;
        widget.hidden=currency!=='USD';
        var placement=widget.querySelector('afterpay-placement')||(widget.nextElementSibling&&widget.nextElementSibling.tagName==='AFTERPAY-PLACEMENT'?widget.nextElementSibling:null);
        if(placement){placement.hidden=currency!=='USD';placement.dataset.amount=amount();}
      }
      function initialize(){
        if(!alive||!window.Afterpay||!window.Afterpay.createPlacements)return;
        window.Afterpay.createPlacements({targetSelector:'#'+CSS.escape(widget.id),attributes:{locale:'en_US',currency:'USD',amount:amount(),aprLoansAvailable:'true'}});update();
      }
      var observer=new MutationObserver(update);observer.observe(price,{attributes:true,attributeFilter:['data-nt-money-cents']});
      window.addEventListener('nt:currency-change',update);
      dispose.push(function(){observer.disconnect();window.removeEventListener('nt:currency-change',update);});
      update();
      if(window.Afterpay)initialize();
      else{
        if(!window.ntAfterpayReady)window.ntAfterpayReady=new Promise(function(resolve,reject){
          var script=document.createElement('script');script.src='https://js.afterpay.com/afterpay-1.x.js';script.async=true;script.onload=resolve;script.onerror=reject;document.head.append(script);
        }).catch(function(){window.ntAfterpayReady=null;});
        window.ntAfterpayReady.then(initialize);
      }
    }
  }
  function init(){document.querySelectorAll('[data-nt-product]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('nt:product:mount',function(event){mount(event.target);});
})();
